<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Notes</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/notes.PNG" class="img-fluid" />
        <div class="card-text row" *ngIf="!preview">
            <div class="col-md-12">
                <mat-form-field class="lines-3">
                    <mat-label>Notes</mat-label>
                    <textarea matInput [(ngModel)]="favorite.comment" (ngModelChange)="edit($event)"></textarea>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>
